module.exports = __webpack_public_path__ + "guide-notice02.a2da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-notice02.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-notice02.svg
// module chunks = main